export enum GmoContent {
  NoGmo = 1,
  ContainsGmo = 2,
  IsGmoProduct = 3
}

(GmoContent as any).__typeName = 'GmoContent';
